import { DataValidator, IsNumber, IsString, Required, transformKeys } from "@/utils/type-vaildator";
import api from "./api";

interface RsapubResponse {
  exponent: number;
  module: string;
  rsa_id: string;
}

class RsapubData {
  @Required("Exponent cannot be empty")
  @IsNumber("Exponent must be a number")
  exponent: number;

  @Required("Module cannot be empty")
  @IsString("Module must be a string")
  module: string;

  @Required("RsaId cannot be empty")
  @IsString("RsaId must be a string")
  rsaId: string;
}

const transformAndValidateLogin = (
  response: RsapubResponse
): RsapubData => {
  const transformedData = transformKeys(response);

  try {
    return DataValidator.validateOrThrow(transformedData, RsapubData);
  } catch (error) {
    console.error("Rsapub data validation failed:", error.message);
    throw error;
  }
};  

export const rsapub = async () => {
  const response = await api.get<RsapubResponse>("/rsapub");
  const validatedData = transformAndValidateLogin(response.data);
  return validatedData;
};
